import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SemanticSearchPropertyDto} from "../types/SemanticSearchPropertyDto";
import {getAmplitudeSemanticSearchPropertyListItem} from "./get_amplitude_semantic_search_property_list_item";
import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

interface ITrackAmplitudeSemanticSearchViewItemListParams {
    properties: SemanticSearchPropertyDto[];
    modalSize: AmplitudeSemanticSearchModalSize | null;
    analyticSessionId: string | null | undefined;
}

export const trackAmplitudeSemanticSearchViewItemList = ({properties, modalSize, analyticSessionId}: ITrackAmplitudeSemanticSearchViewItemListParams) => {
    trackAmplitudeEvent("view_item_list", {
        item_list_id: null,
        item_list_name: "Asystent AI",
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize,
        products: properties.map((property, index) => getAmplitudeSemanticSearchPropertyListItem({property, index}))
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SemanticSearchPropertyDto} from "../types/SemanticSearchPropertyDto";
import {getAmplitudeSemanticSearchPropertyListItem} from "./get_amplitude_semantic_search_property_list_item";
import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";
import {SEMANTIC_SEARCH_AMPLITUDE_LOCATION} from "./semantic_search_amplitude_location";

interface ITrackAmplitudeSemanticSearchViewItemListParams {
    properties: SemanticSearchPropertyDto[];
    modalSize: AmplitudeSemanticSearchModalSize | null;
    analyticSessionId: string | null | undefined;
}

export const trackAmplitudeSemanticSearchViewItemList = ({properties, modalSize, analyticSessionId}: ITrackAmplitudeSemanticSearchViewItemListParams) => {
    trackAmplitudeEvent("view_item_list", {
        item_list_id: null,
        item_list_name: "Asystent AI",
        location: SEMANTIC_SEARCH_AMPLITUDE_LOCATION,
        analytic_session_id: analyticSessionId ?? null,
        modal_size: modalSize,
        products: properties.map((property, index) => getAmplitudeSemanticSearchPropertyListItem({property, index}))
    });
};
